import { Component, Inject, OnInit, Optional } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { UtilityService } from '@app/core/services/utility.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2TableItem, P2TableService } from '@app/services/p2-table.service';

@Component({
    selector: 'tt-p2-table',
    templateUrl: './p2-table.component.html',
    styleUrls: ['./p2-table.component.css'],
    standalone: false,
})
export class P2TableComponent implements OnInit {
    public readonly tabletSize: MediaQueryList;

    public itemState = '';

    public p2TableKeyno = '';

    public tables: P2TableItem[] = [];

    private navigator?: TTViewNavigator;

    constructor(
        private p2Table: P2TableService,
        private utility: UtilityService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async loadTables(): Promise<void> {
        this.tables = await this.p2Table.listTables();
        this.itemState = this.tables.reduce((state, item) => item.item_state || state, '');
    }

    public async updateList(): Promise<void> {
        this.p2TableKeyno = '';
        await this.loadTables();
    }

    public openTable(item: P2TableItem, event?: MouseEvent): void {
        if (this.tabletSize.matches && this.itemState === 'p2tableedit') {
            this.p2TableKeyno = `${item.item_id}`;
            return;
        }

        this.navigateToEdit(`${item.item_id}`, event);
    }

    public createTable(event?: MouseEvent): void {
        if (this.tabletSize.matches && this.itemState === 'p2tableedit') {
            this.p2TableKeyno = '0';
            return;
        }

        this.navigateToEdit('0', event);
    }

    public ngOnInit(): void {
        void this.loadTables();
    }

    private navigateToEdit(keyno: string, event?: MouseEvent): void {
        const target = {
            to: 'p2tableedit',
            parms: { p2_table_keyno: keyno }
        };

        if (event && this.navigator && this.utility.isModifierKeyPressed(event)) {
            void this.navigator.newTab(target);
        } else {
            void this.navigator?.go(target);
        }
    }
}
